<template>
    <div>
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('bookings.headline.license_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="license_amount"
                        :required="true"
                        type="number"
                        step="1"
                        v-model="fields.licenseAmount"
                    >
                        {{ trans('bookings.label.license_amount') }}
                    </form-input>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary" >
                    {{ trans('licenses.label.update_bindingly') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'booking': {
            type: Object,
            default: () => { return {} }
        },
    },

    data() {
        return {
            fields: {
                licenseAmount: this.old('license_amount', this.booking.license_amount),
            },
        };
    },
}
</script>
